module.exports = __webpack_public_path__ + "img/ico_dried_flower.d37bfc2e.svg";